<template>
  <b-card no-body class="mb-1 kpi-bar-card">
    <div class="d-flex align-items-stretch kpi-bar-inner">

      <!-- Total Calls -->
      <div
        class="kpi-stat text-center px-2 py-75 flex-fill"
        :class="{ 'kpi-active': activeFilter === 'all' }"
        style="cursor:pointer;"
        @click="$emit('filter', 'all')"
      >
        <small class="text-muted d-block mb-25">Total Calls</small>
        <feather-icon icon="PhoneIcon" size="14" class="text-primary mr-25" />
        <b-spinner v-if="isLoading" small variant="primary" class="kpi-spinner" />
        <span v-else class="font-weight-bold h5 mb-0 text-primary">{{ kpi.total.toLocaleString('en-IN') }}</span>
      </div>

      <div class="kpi-divider" />

      <!-- Connected -->
      <div
        class="kpi-stat text-center px-2 py-75 flex-fill"
        :class="{ 'kpi-active': activeFilter === 'connected' }"
        style="cursor:pointer;"
        @click="$emit('filter', 'connected')"
      >
        <small class="text-muted d-block mb-25">Connected</small>
        <feather-icon icon="PhoneCallIcon" size="14" class="text-success mr-25" />
        <b-spinner v-if="isLoading" small variant="success" class="kpi-spinner" />
        <span v-else class="font-weight-bold h5 mb-0 text-success">
          {{ kpi.connected.toLocaleString('en-IN') }}<template v-if="kpi.pageScoped">+</template>
        </span>
        <small v-if="!isLoading && kpi.total > 0" class="text-muted d-block">
          {{ kpi.connectionRate }}% connected
        </small>
      </div>

      <div class="kpi-divider" />

      <!-- Not Answered -->
      <div
        class="kpi-stat text-center px-2 py-75 flex-fill"
        :class="{ 'kpi-active': activeFilter === 'not-answered' }"
        style="cursor:pointer;"
        @click="$emit('filter', 'not-answered')"
      >
        <small class="text-muted d-block mb-25">Not Answered</small>
        <feather-icon icon="PhoneMissedIcon" size="14" class="text-warning mr-25" />
        <b-spinner v-if="isLoading" small variant="warning" class="kpi-spinner" />
        <span v-else class="font-weight-bold h5 mb-0 text-warning">
          {{ kpi.notAnswered.toLocaleString('en-IN') }}<template v-if="kpi.pageScoped">+</template>
        </span>
        <small v-if="!isLoading && kpi.attentionFromOrg" class="text-muted d-block">org today</small>
      </div>

      <div class="kpi-divider" />

      <!-- Failed -->
      <div
        class="kpi-stat text-center px-2 py-75 flex-fill"
        :class="{ 'kpi-active': activeFilter === 'failed' }"
        style="cursor:pointer;"
        @click="$emit('filter', 'failed')"
      >
        <small class="text-muted d-block mb-25">Failed</small>
        <feather-icon icon="PhoneOffIcon" size="14" class="text-danger mr-25" />
        <b-spinner v-if="isLoading" small variant="danger" class="kpi-spinner" />
        <span v-else class="font-weight-bold h5 mb-0 text-danger">
          {{ kpi.failed.toLocaleString('en-IN') }}<template v-if="kpi.pageScoped">+</template>
        </span>
        <small v-if="!isLoading && kpi.failedIsRows && !kpi.pageScoped" class="text-muted d-block">in period</small>
      </div>

      <div class="kpi-divider" />

      <!-- Missed Calls -->
      <div
        class="kpi-stat text-center px-2 py-75 flex-fill"
        :class="{ 'kpi-active': activeFilter === 'missed' }"
        style="cursor:pointer;"
        @click="$emit('filter', 'missed')"
      >
        <small class="text-muted d-block mb-25">Missed Calls</small>
        <feather-icon icon="PhoneIncomingIcon" size="14" class="text-warning mr-25" />
        <b-spinner v-if="isLoading" small variant="warning" class="kpi-spinner" />
        <span v-else class="font-weight-bold h5 mb-0 text-warning">
          {{ kpi.missed.toLocaleString('en-IN') }}<template v-if="kpi.pageScoped">+</template>
        </span>
        <small v-if="!isLoading && kpi.attentionFromOrg" class="text-muted d-block">org today</small>
        <small v-else-if="!isLoading && kpi.missedRangeLabel" class="text-muted d-block">{{ kpi.missedRangeLabel }}</small>
      </div>

      <div class="kpi-divider" />

      <!-- Avg Duration (not clickable) -->
      <div class="kpi-stat text-center px-2 py-75 flex-fill">
        <small class="text-muted d-block mb-25">Avg Duration</small>
        <feather-icon icon="ClockIcon" size="14" class="text-secondary mr-25" />
        <b-spinner v-if="isLoading" small variant="secondary" class="kpi-spinner" />
        <span v-else class="font-weight-bold h5 mb-0 text-secondary">{{ kpi.avgDuration }}</span>
      </div>

    </div>
  </b-card>
</template>

<script>
import { BCard, BSpinner } from 'bootstrap-vue'

export default {
  name: 'MyCallsKpiCards',

  components: {
    BCard,
    BSpinner,
  },

  props: {
    kpi: { type: Object, required: true },
    isLoading: { type: Boolean, default: false },
    activeFilter: { type: String, default: 'all' },
  },
}
</script>

<style scoped>
.kpi-bar-card {
  border-radius: 0.5rem;
  overflow: hidden;
}
.kpi-bar-inner {
  flex-wrap: wrap;
}
.kpi-stat {
  min-width: 110px;
  transition: background-color 0.15s ease;
}
.kpi-stat[style*="cursor:pointer"]:hover {
  background-color: rgba(0, 0, 0, 0.03);
}
.kpi-active {
  border-bottom: 3px solid #7367f0;
  background-color: rgba(115, 103, 240, 0.06);
}
.dark-layout .kpi-active {
  background-color: rgba(115, 103, 240, 0.12);
}
.dark-layout .kpi-stat[style*="cursor:pointer"]:hover {
  background-color: rgba(255, 255, 255, 0.04);
}
.kpi-divider {
  width: 1px;
  background-color: rgba(0, 0, 0, 0.08);
  align-self: stretch;
  flex-shrink: 0;
}
.kpi-spinner {
  vertical-align: middle;
}
.dark-layout .kpi-divider {
  background-color: rgba(255, 255, 255, 0.08);
}

/* Mobile: 2-column grid for KPI stats */
@media (max-width: 576px) {
  .kpi-bar-inner {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .kpi-stat {
    min-width: unset;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
  .kpi-divider {
    display: none;
  }
  .dark-layout .kpi-stat {
    border-bottom-color: rgba(255, 255, 255, 0.06);
  }
}
</style>
